"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider, useTheme } from "next-themes";
import { useEffect, type ReactNode } from "react";
export type ColorScheme = "light" | "dark" | "darkest";
const THEMES: ColorScheme[] = ["light", "dark", "darkest"];

// Keep the PWA / browser status-bar colour in sync with the active theme's
// background, so the top part of the screen matches the page instead of staying
// white when the user switches to a dark scheme.
function ThemeColorMeta() {
  const $ = _c(2);
  const {
    theme
  } = useTheme();
  let t0;
  if ($[0] !== theme) {
    t0 = [theme];
    $[0] = theme;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  const bg = getComputedStyle(document.documentElement).getPropertyValue("--background").trim();
  if (!bg) {
    return;
  }
  const color = `hsl(${bg})`;
  const metas = document.querySelectorAll("meta[name=\"theme-color\"]");
  if (metas.length === 0) {
    const meta = document.createElement("meta");
    meta.name = "theme-color";
    meta.content = color;
    document.head.appendChild(meta);
    return;
  }
  metas.forEach(meta_0 => {
    meta_0.content = color;
  });
}
export function SettingsProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ThemeColorMeta data-sentry-element="ThemeColorMeta" data-sentry-source-file="SettingsProvider.tsx" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <ThemeProvider attribute="class" themes={THEMES} defaultTheme="light" enableSystem={false} enableColorScheme={false} disableTransitionOnChange={true} storageKey="settings.colorScheme" data-sentry-element="ThemeProvider" data-sentry-component="SettingsProvider" data-sentry-source-file="SettingsProvider.tsx">{t1}{children}</ThemeProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function useSettings() {
  const $ = _c(9);
  const {
    theme,
    setTheme
  } = useTheme();
  const colorScheme = theme as ColorScheme ?? "light";
  let t0;
  if ($[0] !== setTheme) {
    t0 = value => setTheme(value);
    $[0] = setTheme;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== colorScheme || $[3] !== setTheme) {
    t1 = () => setTheme(THEMES[(THEMES.indexOf(colorScheme) + 1) % THEMES.length]);
    $[2] = colorScheme;
    $[3] = setTheme;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== colorScheme || $[6] !== t0 || $[7] !== t1) {
    t2 = {
      colorScheme,
      setColorScheme: t0,
      toggleColorScheme: t1
    };
    $[5] = colorScheme;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}